/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createPedigree = /* GraphQL */ `
  mutation CreatePedigree(
    $input: CreatePedigreeInput!
    $condition: ModelPedigreeConditionInput
  ) {
    createPedigree(input: $input, condition: $condition) {
      id
      IssuedTo
      ClientId
      Invoice
      Published
      TransactionDate
      PurchaseDate
      PedType
      GroupID
      ExpiresAt
      updatedAt
      createdAt
      PDF {
        bucket
        region
        key
      }
      Transaction {
        Product
        ItemId
        Strength
        DoseForm
        ContainerSize
        LotId
        LotExp
        Quantity
      }
      Manufacturer {
        Name
        Address
        City
        State
        Zip
        BulkLotId
        Exp
        ContainerSize
        NDC
        Invoice
        TransactionDate
      }
      Distributors {
        Invoice
        TransactionDate
        Name
        Address
        City
        State
        Zip
      }
    }
  }
`;
export const updatePedigree = /* GraphQL */ `
  mutation UpdatePedigree(
    $input: UpdatePedigreeInput!
    $condition: ModelPedigreeConditionInput
  ) {
    updatePedigree(input: $input, condition: $condition) {
      id
      IssuedTo
      ClientId
      Invoice
      Published
      TransactionDate
      PurchaseDate
      PedType
      GroupID
      ExpiresAt
      updatedAt
      createdAt
      PDF {
        bucket
        region
        key
      }
      Transaction {
        Product
        ItemId
        Strength
        DoseForm
        ContainerSize
        LotId
        LotExp
        Quantity
      }
      Manufacturer {
        Name
        Address
        City
        State
        Zip
        BulkLotId
        Exp
        ContainerSize
        NDC
        Invoice
        TransactionDate
      }
      Distributors {
        Invoice
        TransactionDate
        Name
        Address
        City
        State
        Zip
      }
    }
  }
`;
export const deletePedigree = /* GraphQL */ `
  mutation DeletePedigree(
    $input: DeletePedigreeInput!
    $condition: ModelPedigreeConditionInput
  ) {
    deletePedigree(input: $input, condition: $condition) {
      id
      IssuedTo
      ClientId
      Invoice
      Published
      TransactionDate
      PurchaseDate
      PedType
      GroupID
      ExpiresAt
      updatedAt
      createdAt
      PDF {
        bucket
        region
        key
      }
      Transaction {
        Product
        ItemId
        Strength
        DoseForm
        ContainerSize
        LotId
        LotExp
        Quantity
      }
      Manufacturer {
        Name
        Address
        City
        State
        Zip
        BulkLotId
        Exp
        ContainerSize
        NDC
        Invoice
        TransactionDate
      }
      Distributors {
        Invoice
        TransactionDate
        Name
        Address
        City
        State
        Zip
      }
    }
  }
`;
